export const searchResultsPageId = 'search-results';
